<div class="tabs-container" role="navigation">
    @for (tab of visibleOptions(); track tab.id) {
        <div
            class="tab"
            role="button"
            tabindex="0"
            [class.active]="tab.id === selectedTabId()"
            [class.failure]="tab.failure"
            [class.disabled]="tab.disabled"
            (click)="selectedTabId.set(tab.id)"
            (keydown.enter)="selectedTabId.set(tab.id)"
        >
            {{ tab.label }}
            @if (tab.elementCount !== undefined) {
                ({{ tab.elementCount }})
            }
        </div>
    }
</div>
<div class="tab-underline" [class.visible]="divider()"></div>
